import React, { useEffect } from 'react'
import { type Division } from '../../../models/Division'
import { ButtonType } from '../../../components/GenericButton/styles'
import { Typography } from '@mui/material'
import { useAppDispatch } from '../../../store'
import { grey } from '../../../colors'
import { archiveDivisionApi } from '../../../store/slices/reportHierarchySlice/apis'
import { archiveLoading } from '../../../store/slices/reportHierarchySlice/selectors'
import { useTheme } from '@mui/material/styles'
import DefaultModalActions from '../../../components/GenericModal/DefaultModalActions'
import { type ApiError } from '../../../models/Common'
import { notification } from '../../../components/Notifications'

interface ArchiveDivisionDivisionProps {
  selectedRow?: Division
  handleCloseModal?: () => void
  showErrorModal?: () => void
  setErrorMessage?: (arg: string) => void
  isTaskRunning?: boolean
  onTaskBlock?: () => void
}

const ArchiveDivision: React.FC<ArchiveDivisionDivisionProps> = ({ selectedRow, handleCloseModal, showErrorModal, setErrorMessage, isTaskRunning, onTaskBlock }) => {
  const dispatch = useAppDispatch()
  const isLoading = archiveLoading()
  const theme = useTheme()

  useEffect(() => {
    if (selectedRow != null && isTaskRunning) {
      onTaskBlock?.()
      handleCloseModal?.()
    }
  }, [selectedRow])

  const handleDelete = async (): Promise<void> => {
    try {
      await dispatch(archiveDivisionApi({ urlId: selectedRow?.divisionId })).unwrap().then(() => { handleCloseModal?.() })
    } catch (error) {
      const customError = error as ApiError
      if (customError && customError.status === 422) {
        setErrorMessage?.(customError.message || 'Unknown error')
        showErrorModal?.()
        return
      }
      notification(customError?.message ?? 'Internal server error', { variant: 'error' })
    }
  }

  return (
    <>
      <Typography fontSize='14px' lineHeight={theme.spacing(5)} color={grey[850]}>
        You will not be able to recover this Academic Unit. All references to it will be hidden.
      </Typography>
      <DefaultModalActions
        confirmButtonProps={{
          onClick: handleDelete,
          text: 'Archive',
          loading: isLoading,
          buttonType: ButtonType.Destructive
        }}
        destructiveButtonProps={{
          onClick: handleCloseModal
        }}
      />
    </>

  )
}

export default ArchiveDivision
